<h1>Albion Online Market Top Traded Items</h1>
@if (!(authService.user$ | async)) {
  <div style="margin-top: 15px">
    You need to <button mat-flat-button color="accent" (click)="authService.googleSignIn()"><mat-icon>login</mat-icon>LOGIN</button> to use this tool.
  </div>
}

<div style="margin: 10px 0px">
  <mat-accordion>
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title> Tutorial </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>
      <p>Our servers at Albion Free Market tirelessly operate 24/7, meticulously analyzing every single market history to identify the top-selling items in each Market.</p>
      <p>
        To maximize the benefits of this tool, we recommend running
        <a href="https://www.albion-online-data.com/" target="_blank">The Albion Online Data Project</a> client while you play. This will transmit all the market histories you encounter in-game to the Albion Free Market servers, enhancing
        the likelihood of uncovering the best deals.
      </p>
      <p>You have the flexibility to select a single day or a range of days. The displayed values represent a daily average (total divided by the number of days).</p>
      <p>This tool consolidates all item qualities into a single line. Therefore, the daily silver and amount reflect the cumulative total of all different qualities of the same item.</p>
      <p>
        Remember, this is a community tool, designed to empower you, the community, to compete with major market players, RMTers, and guilds with dedicated systems. Its effectiveness increases with more usage. So, if you find it beneficial,
        please share it with your friends and guildmates.
      </p>
    </mat-expansion-panel>
  </mat-accordion>
</div>
@if ((authService.user$ | async) && (jsonReaderService.hasLoaded$ | async)) {
    <!-- MARK: FILTERS -->
    <form [formGroup]="filterFormGroup" class="flex-container-row" style="align-items: center; gap: 8px">
      <button
        class="form-item-button"
        style="align-self: center; margin: 0px"
        mat-mini-fab
        (click)="updateTopItems()"
        [disabled]="loadingBarService.getDisableSlowAPIButtons()"
        color="primary"
        matTooltip="Refresh Top Items"
        aria-label="Refresh Top Items Button"
      >
        <mat-icon>refresh</mat-icon>
      </button>

      <app-categories-menu [shopCategories]="this.jsonReaderService.shopCategoriesWithTradeableItems()" [(selectedCategories)]="this.selectedCategories" />
      <mat-form-field>
        <mat-label>Location</mat-label>
        <mat-select formControlName="locationForm">
          @for (location of locations; track location) {
            <mat-option [value]="location">{{ location.displayName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Sort By</mat-label>
        <mat-select [formControl]="filterFormGroup.controls.sortBy">
          @for (sort of sortOptions; track $index) {
            <mat-option [value]="sort.value">{{ sort.displayName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate formControlName="startDateForm" placeholder="Start date" />
          <input matEndDate formControlName="endDateForm" placeholder="End date" />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

        @if (filterFormGroup.controls.startDateForm.hasError('matStartDateInvalid')) {
          <mat-error>Invalid start date</mat-error>
        }
        @if (filterFormGroup.controls.endDateForm.hasError('matEndDateInvalid')) {
          <mat-error>Invalid end date</mat-error>
        }
      </mat-form-field>
      <mat-form-field style="width: 99%">
        <mat-label>Filter</mat-label>
        <input matInput formControlName="filterInput" placeholder="Ex. Bag" #input />
        @if (filterFormGroup.controls.filterInput.value) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="filterFormGroup.controls.filterInput.setValue('')" aria-label="Clear Filter">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </form>
  <!-- MARK: TABLE -->
  <div class="flex-container-column">
    <div class="mat-elevation-z8 table">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="itemId">
          <th mat-header-cell *matHeaderCellDef>Item</th>
          <td mat-cell *matCellDef="let item">
            <div style="display: flex; align-items: center">
              <app-item-image [item]="item.item" [size]="50" [hideTooltip]="true" />
              {{ item.item.localizedName }}
              <app-copy-text-button [text]="item.item.localizedName"></app-copy-text-button>
              <app-check-price-button [itemUniqueName]="item.item.uniqueName"></app-check-price-button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="totalPrice">
          <th mat-header-cell *matHeaderCellDef>Daily Silver</th>
          <td mat-cell *matCellDef="let item">{{ item.totalPrice | smallNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Daily Amount</th>
          <td mat-cell *matCellDef="let item">{{ item.amount | smallNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="averagePrice">
          <th mat-header-cell *matHeaderCellDef>Average Price</th>
          <td mat-cell *matCellDef="let item">{{ item.totalPrice / item.amount | number: '1.0-0' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['itemId', 'totalPrice', 'amount', 'averagePrice']; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: ['itemId', 'totalPrice', 'amount', 'averagePrice']"></tr>
      </table>
    </div>
    <div>
      <mat-paginator #paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons aria-label="Select page of flips"> </mat-paginator>
    </div>
  </div>
}
